module.exports = __webpack_public_path__ + "static/media/logo.21ec5fc4.png";